import { render } from "./PaymentResult.vue?vue&type=template&id=083f930a&scoped=true"
import script from "./PaymentResult.vue?vue&type=script&lang=js"
export * from "./PaymentResult.vue?vue&type=script&lang=js"

import "./PaymentResult.vue?vue&type=style&index=0&id=083f930a&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-083f930a"

export default script